import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishTranslation from "@translations/en-app.json";
import spanishTranslation from "@translations/es-app.json";
import { getPrefferedLanguage } from "@/v2/data-access";
const I18N_TRANSLATION_CONFIG = {
    resources: {
        en: {
            translation: englishTranslation,
        },
        es: {
            translation: spanishTranslation,
        },
    },
    lng: getPrefferedLanguage(),
    interpolation: {
        escapeValue: false,
    },
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
        console.warn(`Missing translation for key "${key}" in language "${lng}" and namespace "${ns}".`);
        return fallbackValue !== undefined ? fallbackValue : `[${key}]`;
    },
};
export function initializeTranslations() {
    i18n.use(initReactI18next).init(I18N_TRANSLATION_CONFIG);
}
export function translate(key) {
    if (!key || typeof key !== "string")
        return ""; //==>
    const transalatedValue = i18n.t(key);
    return typeof transalatedValue !== "string" ? "-" : i18n.t(key);
}
